import { LocatorDetailButton, LocatorWindowDetailButton } from "./input-locator-buttons.component";
export const autocompleteDefaultMaxFetchItems = 100;
export const autocompleteDefaultDebounceMs = 200;
export const autocompleteDefaultCacheOptions = true;
export const locatorDefaultVisibleButtons = [LocatorDetailButton, LocatorWindowDetailButton];